import ShareMsgBase from './A_G.ShareMsgBase';

export class MsgFortuneCookie extends ShareMsgBase {
  /**
   * The message that is shared when you share a fortune cookie message
   * @param {string} imgID
   * @param {string} txt
   * @param {function} onAllImagesReadyCallback
   */
  constructor(imgID, txt, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);
    const avatar = G.makeExtImage(496, 113, OMT.envData.settings.user.avatar, 'avatar_m', 0, this, false, (img) => {
      img.width = img.height = 138;

      this._objectLoadComplete();
    });
    avatar.angle = 5.62;
    this.img = this._addExtImage(0, 0, `img/${imgID}.png`, 0, 672, 354);
    this.txt = new G.Text(310, 89, txt.replace('<<name>>', "You"), 'fortuneCookie-shareStyle', 0.5, 330, 120, true, 'center');
    this.txt.angle = -1.75;
    this.add(this.txt);

    this._objectLoadComplete();
  }
}
G.MsgFortuneCookie = MsgFortuneCookie;
